<div class="content-wrap">
	<div id="content">
		<div ng-class="loading ? 'not-active' : ''" id="meterWidgetContainer" ng-controller="WidgetController">
			<app-loader *ngIf="loading"></app-loader>
			<script type="text/javascript" src="https://apis.google.com/js/api.js"></script>
			<!-- <iframe id="datainput-widget" ng-src="{{getIframeSrc()}}" style="border: none;width: 100%;"></iframe> -->
	
			<app-widget id="datainput-widget" [leed_id]="appData.get('leed_id')" [src]="'data-input'" [param]="'&type=' + type + '&action=' + action" [width]="'100%'"></app-widget>
		</div>
	</div>
</div>